import ClientRowComponent from './client-row-component';

/***
 * The static representation of a single client (like a client or a facility).
 */
const ClientRow = angular
    .module('FacilityData.ClientAdmin.ClientRow', [])
    .component('clientRow', ClientRowComponent)
    .name;

export default ClientRow;


// WEBPACK FOOTER //
// ./app/components/client-admin/client-row/client-row.js